import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';
import {
  Message,
  MessageClasses,
  MessageModule,
  MessageStyle,
} from 'primeng/message';
import { TranslatePipe } from '@ngx-translate/core';

export interface MessageFieldProps extends FormlyFieldProps {
  template: string;
  severity:
    | 'success'
    | 'info'
    | 'warn'
    | 'secondary'
    | 'contrast'
    | 'error'
    | null
    | undefined;
}

@Component({
  selector: 'message-field',
  standalone: true,
  imports: [...FORM_IMPORTS, MessageModule, TranslatePipe],
  template: `<p-message [severity]="props.severity"
    ><div
      [innerHTML]="props.template | translate: field.formControl.value || {}"
    ></div
  ></p-message> `,
})
export class MessageFieldType extends FieldType<
  FieldTypeConfig<MessageFieldProps>
> {}
